// import styles from "./home-page.module.css";
// import newLogo from '../assets/images/background.png';
import HoursSection from "../components/HoursSection";
import ContactSection from "../components/ContactSection";
import HeroSection from "./HeroSection";


function HomePage(){
    return (
            <div>
                    <HeroSection/>
                    <HoursSection/>
                    <ContactSection/>
            </div>
    )
}



export default HomePage;